// This file was auto-generated by Fern from our API Definition.
import { normalizeClientOptionsWithAuth } from "../../../../BaseClient.js";
import { mergeHeaders } from "../../../../core/headers.js";
import * as core from "../../../../core/index.js";
import * as environments from "../../../../environments.js";
import { handleNonStatusCodeError } from "../../../../errors/handleNonStatusCodeError.js";
import * as errors from "../../../../errors/index.js";
import * as AgentaApi from "../../../index.js";
export class EventsClient {
    _options;
    constructor(options) {
        this._options = normalizeClientOptionsWithAuth(options);
    }
    /**
     * @param {AgentaApi.EventQueryRequest} request
     * @param {EventsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.events.queryEventsRpc()
     */
    queryEventsRpc(request = {}, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__queryEventsRpc(request, requestOptions));
    }
    async __queryEventsRpc(request = {}, requestOptions) {
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "events/query"),
            method: "POST",
            headers: _headers,
            contentType: "application/json",
            queryParameters: requestOptions?.queryParams,
            requestType: "json",
            body: request,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/events/query");
    }
}
